/**
 * Armazenamento local de demonstração (localStorage).
 * Toda a aplicação acessa os dados SOMENTE pelos serviços em ./api.js.
 * Para conectar o Supabase, basta reimplementar ./api.js mantendo as mesmas
 * assinaturas assíncronas — a interface não precisa mudar.
 */
import { SEED_COMPANIES, SEED_OPPORTUNITIES, SEED_REPORTS } from '@/data/demoSeed';
import { DEFAULT_CATEGORIES } from '@/data/taxonomy';

const KEY = 'blb:demo:v1';
const listeners = new Set();
let storageOk = true;

const buildSeed = () => ({
  version: 1,
  seededAt: new Date().toISOString(),
  companies: SEED_COMPANIES,
  opportunities: SEED_OPPORTUNITIES,
  reports: SEED_REPORTS,
  users: [],
  categories: DEFAULT_CATEGORIES,
  contacts: [],
  session: null,
});

function load() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return buildSeed();
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.companies)) return buildSeed();
    return parsed;
  } catch (e) {
    storageOk = false;
    return buildSeed();
  }
}

let state = load();

function persist() {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(state));
    storageOk = true;
  } catch (e) {
    storageOk = false;
  }
}
persist();

export const store = {
  getState: () => state,
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  /** @param {(s:any)=>any} updater */
  update(updater) {
    state = { ...state, ...updater(state) };
    persist();
    listeners.forEach((l) => l());
    if (!storageOk) throw new Error('Não foi possível salvar neste navegador (armazenamento indisponível ou cheio).');
  },
  reset() {
    state = buildSeed();
    persist();
    listeners.forEach((l) => l());
  },
  isStorageAvailable: () => storageOk,
};

// Sincroniza entre abas do mesmo navegador.
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) {
      state = load();
      listeners.forEach((l) => l());
    }
  });
}
